module.exports = __webpack_public_path__ + "f8d01a984a07a2a6c7e346d7fa4d1493.png";